import request from '@/utils/request'

/**
 * 品牌入住
 * @param data
 */
export const brandJoin = (data) => {
  return request({
    url: '/sol/brand_join',
    method: 'post',
    data: data
  })
}


/**
 * 项目登记
 * @param data
 */
 export const addProRegistration = (data) => {
  return request({
    url: '/sol/pc/designer_partner/insertProjectRegistration',
    method: 'post',
    data: data
  })
}


/**
 * // 品牌推荐表单 /pc/brandRecommendation/insertBrandRecommendation
 * @param data
 */
 export const addBrandRecommendation = (data) => {
  return request({
    url: '/sol/pc/designer_partner/insertBrandRecommendation',
    method: 'post',
    data: data
  })
}

/***
 * 设计师合伙人申请
 *  /pc/designer_partner/apply
 */
 export const applyDesigner = (data) => {
  return request({
    url: '/sol/pc/designer_partner/apply',
    method: 'post',
    data: data
  })
}
// 获得业态和系统   5是系统  6是业态
export const getCommData =(params)=>{
  return request({
    url:`/sol/common/common_type_data/${params}`,
    method:'get'
  })

}
// 获得状态合伙人的 申请状态
export const getJoinStatus =(params) =>{
  return request({
    url:`/sol/pc/designer_partner/getJoinStatus/${params}`,
    method:'get'
  })
}

export const checkFailMsg = (params) => {
  return request({
    url: `/sol/pc/designer_partner/message`,
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/brand/brands.js